import { Component, inject } from '@angular/core';

import { APP_AUTHENTICATION_SERVICE_TOKEN, AuthenticationService } from '../../services/authentication/authentication.interface';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  standalone: false,
})
export class ProfileMenuComponent {
  private readonly _authenticationService: AuthenticationService = inject(APP_AUTHENTICATION_SERVICE_TOKEN);

  public onLogout(): void {
    this._authenticationService.logout();
  }
}
